<template>
  <ShokurekishoJobProjectListPanel
    :projects="projects"
    :is-active="isActive"
    add-label="参加プロジェクト・実績を追加"
    delete-item-label="このプロジェクト・実績を削除"
    @add-project="emit('add-project')"
    @delete-job="emit('delete-job')"
    @ok="emit('ok')"
    @move-up="emit('move-up', $event)"
    @move-down="emit('move-down', $event)"
    @delete-item="emit('delete-item', $event)"
  >
    <template #default="{ project }">
      <el-form class="history-form edit-form-item">
        <div class="item-name">
          <label for="projectTitle">プロジェクトまたは業務名</label>
        </div>
        <el-form-item prop="projectTitle">
          <el-input
            class="input-lg"
            type="textbox"
            id="projectTitle"
            :autosize="{ minRows: 1, maxRows: 4 }"
            placeholder="プロジェクトまたは業務名"
            v-model="project.projectTitle"
            ref="desc"
          >
          </el-input>
          <span></span>
        </el-form-item>

        <div class="item-name"><label for="">期間</label></div>
        <div class="form-date">
          <el-form-item prop="startYear">
            <el-input
              class="input-xxs"
              placeholder="2000"
              title="年"
              v-model="project.startYear"
              type="number"
              :min="minYear"
              :max="maxYear"
            >
            </el-input>
            <span>年</span>
          </el-form-item>
          <el-form-item prop="startMonth">
            <el-input
              class="input-xxs input-2-digit"
              placeholder="12"
              title="月"
              v-model="project.startMonth"
              type="number"
              min="1"
              max="12"
            >
            </el-input>
            <span>月から</span>
          </el-form-item>
        </div>
        <div class="form-date">
          <el-form-item prop="endYear">
            <el-input
              class="input-xxs"
              placeholder="2000"
              title="年"
              v-model="project.endYear"
              type="number"
              :min="minYear"
              :max="maxYear"
            >
            </el-input>
            <span>年</span>
          </el-form-item>
          <el-form-item prop="endMonth">
            <el-input
              class="input-xxs input-2-digit"
              placeholder="12"
              title="月"
              v-model="project.endMonth"
              type="number"
              min="1"
              max="12"
            >
            </el-input>
            <span>月まで</span>
          </el-form-item>
        </div>
        <el-form-item prop="contentsOfProject">
          <div class="item-name">
            <label for="contentsOfProject">プロジェクトや業務内容の説明</label>
          </div>
          <el-input
            class="input-lg"
            type="textarea"
            id="contentsOfProject"
            :autosize="{ minRows: 6, maxRows: 8 }"
            placeholder="業務内容やプロジェクトの説明"
            v-model="project.contentsOfProject"
            v-proofread
            ref="desc"
          >
          </el-input>
          <span></span>
        </el-form-item>
      </el-form>
    </template>
  </ShokurekishoJobProjectListPanel>
</template>

<script setup lang="ts">
import ShokurekishoJobProjectListPanel from '@/components/format-edit/shokurekisho/ShokurekishoJobProjectListPanel.vue'
import { useHistoryItemDescResize } from '@/composables/format-edit/useShokurekishoHistoryItem'
import type { ShokurekishoProjectItem } from '@/composables/format-edit/useShokurekishoFormatData'

defineProps<{
  projects?: ShokurekishoProjectItem[]
  isActive: boolean
  minYear: number
  maxYear: number
}>()

const emit = defineEmits<{
  (e: 'add-project'): void
  (e: 'delete-job'): void
  (e: 'ok'): void
  (e: 'move-up', index: number): void
  (e: 'move-down', index: number): void
  (e: 'delete-item', index: number): void
}>()

const { desc } = useHistoryItemDescResize()
</script>
